var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UnauthorizedComponent',{attrs:{"languagestrings":_vm.languagestrings,"toperror":_vm.toperror},on:{"updateLanguage":_vm.updateLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }